import { render, staticRenderFns } from "./StampaOdrGroup.vue?vue&type=template&id=6a904b8f&scoped=true"
import script from "./StampaOdrGroup.vue?vue&type=script&lang=js"
export * from "./StampaOdrGroup.vue?vue&type=script&lang=js"
import style0 from "./StampaOdrGroup.vue?vue&type=style&index=0&id=6a904b8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a904b8f",
  null
  
)

export default component.exports